// <div class="slides"><div class="slides-track"><figure>…</figure>…</div></div> → arrows + dots
// Frames are stacked and switch instantly, like a flipbook.
document.querySelectorAll(".slides").forEach(el => {
  const frames = [...el.querySelector(".slides-track").children]
  const count = frames.length
  const label = el.lang === "ru" ? ["Назад", "Вперёд"] : ["Previous", "Next"]

  el.insertAdjacentHTML("beforeend", `
    <button class="slides-arrow slides-prev" aria-label="${label[0]}">‹</button>
    <button class="slides-arrow slides-next" aria-label="${label[1]}">›</button>
    <div class="slides-dots">${frames.map((_, i) => `<button aria-label="${i + 1}"></button>`).join("")}</div>
  `)
  const prev = el.querySelector(".slides-prev")
  const next = el.querySelector(".slides-next")
  const dots = el.querySelectorAll(".slides-dots button")

  let index = 0
  const show = i => {
    index = Math.max(0, Math.min(count - 1, i))
    frames.forEach((f, j) => f.classList.toggle("is-hidden", j !== index))
    prev.disabled = index === 0
    next.disabled = index === count - 1
    dots.forEach((d, j) => d.toggleAttribute("aria-current", j === index))
  }

  prev.onclick = () => show(index - 1)
  next.onclick = () => show(index + 1)
  dots.forEach((d, i) => d.onclick = () => show(i))
  el.addEventListener("keydown", e => {
    if (e.key === "ArrowLeft") { e.preventDefault(); show(index - 1) }
    if (e.key === "ArrowRight") { e.preventDefault(); show(index + 1) }
  })
  let startX
  el.addEventListener("touchstart", e => startX = e.touches[0].clientX, { passive: true })
  el.addEventListener("touchend", e => {
    const dx = e.changedTouches[0].clientX - startX
    if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1))
  })
  show(0)
})
